import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import config from "../../../config.json";

const getHashToken = () => {
  const hash = window.location.hash || "";
  const queryIndex = hash.indexOf("?");
  if (queryIndex === -1) return null;
  return new URLSearchParams(hash.slice(queryIndex + 1)).get("token");
};

export default function AcceptRestaurantJoin() {
  const [searchParams] = useSearchParams();
  const { token: pathToken } = useParams();
  const token = searchParams.get("token") || pathToken || getHashToken();
  const navigate = useNavigate();

  const [requestInfo, setRequestInfo] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const verifyRequest = async () => {
      if (!token) {
        setError("Invalid or missing token.");
        setVerifying(false);
        return;
      }

      try {
        const response = await axios.get(
          `${config.dev}/franchise/join-request/verify/${encodeURIComponent(token)}`
        );
        setRequestInfo(response.data?.data || null);
      } catch (err) {
        setError(err.response?.data?.error || "Invalid or expired link.");
      } finally {
        setVerifying(false);
      }
    };

    void verifyRequest();
  }, [token]);

  const handleAccept = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(`${config.dev}/franchise/join-request/accept`, {
        token,
      });
      setSuccess(response.data.message || "Restaurant added to franchise.");
      setTimeout(() => navigate("/franchise-restaurants", { replace: true }), 2000);
    } catch (err) {
      setError(err.response?.data?.error || "Failed to accept request.");
    } finally {
      setLoading(false);
    }
  };

  if (verifying) {
    return (
      <div className="reset-password-container">
        <p>Loading join request...</p>
      </div>
    );
  }

  const restaurant = requestInfo?.restaurantId;
  const franchise = requestInfo?.franchiseId;

  return (
    <div className="reset-password-container">
      <h2>Restaurant join request</h2>

      {requestInfo ? (
        <div className="alert alert-info">
          <p className="mb-1">
            Restaurant: <strong>{restaurant?.nameRes}</strong>
          </p>
          <p className="mb-1">
            City: <strong>{restaurant?.city || "-"}</strong>
          </p>
          <p className="mb-1">
            Franchise: <strong>{franchise?.nameFr}</strong>
          </p>
          <p className="mb-0">
            Code: <strong>{franchise?.codeFr}</strong>
          </p>
        </div>
      ) : null}

      {error ? <div className="alert alert-danger">{error}</div> : null}
      {success ? <div className="alert alert-success">{success}</div> : null}

      {!success && requestInfo ? (
        <button className="btn btn-primary" onClick={handleAccept} disabled={loading}>
          {loading ? "Accepting..." : "Accept restaurant"}
        </button>
      ) : null}
    </div>
  );
}
